export default "__VITE_ASSET__CduSuixg__$_?url__"